module.exports = __webpack_public_path__ + "img/appointmentWithdrawal_text.a59bd1b6.png";